import { Flex, Spacer, Text } from '@chakra-ui/react';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { formatter } from '@/src/libs/number-helper';
import { Country } from '@/src/context/FilterListingContext';
import { CountryEnum } from '@/swagger';
import clsx from 'clsx';

const HomeLoanCalculation = ({
  price,
  country,
  className,
}: {
  price: number;
  country: Country;
  className?: string;
}) => {
  const [monthFee, setMonthFee] = useState('0');
  const moneyInput = useRef<HTMLInputElement>(null);
  const percentInput = useRef<HTMLInputElement>(null);
  const sliderInput = useRef<HTMLInputElement>(null);

  const interestRatio = country === CountryEnum.TW ? 1.58 : country === CountryEnum.US ? 4.879 : 'null';

  const getMonthFee = () => {
    const downPayment = moneyInput.current?.value ?? '';
    if (isNaN(parseInt(downPayment, 10))) {
      return 0;
    }
    const remainingValue = price - parseInt(moneyInput.current?.value ?? '0');
    const i = 0.0135 / 12;
    const n = 30 * 12;
    (Math.pow(1 + i, n) * i) / 1 + i;
    const payment = remainingValue * ((i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1));
    setMonthFee(payment.toFixed(2));
  };
  useEffect(() => {
    getMonthFee();
  }, []);
  const updateValueBySlider = (e: ChangeEvent<HTMLInputElement>) => {
    if (sliderInput.current) sliderInput.current.value = e.target.value;
    if (percentInput.current) percentInput.current.value = e.target.value;
    if (moneyInput.current) moneyInput.current.value = ((parseInt(e.target.value) * price) / 1e2).toString();
    getMonthFee();
  };
  const updateValueByPercent = (e: ChangeEvent<HTMLInputElement>) => {
    if (isNaN(parseFloat(e.target.value)) || parseFloat(e.target.value) > 100 || parseFloat(e.target.value) < 0) {
      return;
    } else {
      if (sliderInput.current) sliderInput.current.value = e.target.value;
      if (percentInput.current) percentInput.current.value = e.target.value;
      if (moneyInput.current) moneyInput.current.value = ((parseInt(e.target.value) * price) / 1e2).toString();
      getMonthFee();
    }
  };
  const updateValueByMoney = (e: ChangeEvent<HTMLInputElement>) => {
    if (isNaN(parseFloat(e.target.value)) || parseFloat(e.target.value) > price || parseFloat(e.target.value) < 0) {
      return;
    } else {
      if (sliderInput.current)
        sliderInput.current.value = Math.round(parseInt(e.target.value) / price / 100).toString();
      if (percentInput.current)
        percentInput.current.value = Math.round(parseInt(e.target.value) / price / 100).toString();
      if (moneyInput.current) moneyInput.current.value = e.target.value;
      getMonthFee();
    }
  };
  return (
    <div className={clsx('w-full md:w-4/6 flex flex-col', className)}>
      <p className='text-lg leading-loose font-medium uppercase mb-3'>房貸試算</p>
      <p className=' leading-normal tracking-wide text-dark-grey uppercase mb-4'>寬限期後每月償還本息</p>
      <p className='text-lg leading-loose font-medium text-dark-grey uppercase mb-4'>
        ${formatter.format(parseFloat(monthFee))}
        元/月
      </p>
      <p className=' leading-normal tracking-wide text-dark-grey uppercase mb-5'>
        30 年貸款總年限，{interestRatio}% 銀行利率（參考利率）
      </p>
      <Flex flex={10} w={'100%'} direction={'row'} align={'center'} mb={6}>
        <Flex flex={1.5}>
          <Text fontSize={'lg'} fontWeight={'medium'} color={'gray.900'}>
            頭期款
          </Text>
        </Flex>
        <Flex
          flex={2.5}
          borderColor={'gray.700'}
          borderWidth={1}
          py={2}
          px={3}
          alignItems={'center'}
          flexDirection={'row'}
        >
          <p className={'mr-1'}>$</p>
          <input
            onChange={updateValueByMoney}
            ref={moneyInput}
            defaultValue={`${price * 0.2}`}
            className={' w-full  text-gray700'}
          />
        </Flex>
        <Flex
          flex={1}
          borderColor={'gray.700'}
          borderWidth={1}
          py={2}
          px={3}
          borderLeftWidth={0}
          alignItems={'center'}
          flexDirection={'row'}
        >
          <input
            onChange={updateValueByPercent}
            ref={percentInput}
            defaultValue={`${20}`}
            className={'   w-full  text-gray700'}
          />
          <p>%</p>
        </Flex>
        <Spacer />
      </Flex>

      <input
        ref={sliderInput}
        type='range'
        min='1'
        max='100'
        defaultValue={'20'}
        step={'1'}
        onChange={updateValueBySlider}
      />
    </div>
  );
};
export default HomeLoanCalculation;
